// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index')
